export interface ApplicationStage { id: string; name: string }
export interface ApplicationProcess { stages: ApplicationStage[]; powerQuizEnabled: boolean }

export function readApplicationProcess(value: unknown): ApplicationProcess | null {
  if (!value || typeof value !== "object" || !("stages" in value) || !Array.isArray(value.stages)) return null;
  const stages = value.stages.filter((stage): stage is ApplicationStage =>
    !!stage && typeof stage === "object" && typeof stage.id === "string" && typeof stage.name === "string");
  if (stages.length !== value.stages.length || stages.length < 2) return null;
  return { stages, powerQuizEnabled: "powerQuizEnabled" in value && value.powerQuizEnabled === true };
}
